import { ReactComponent as FlagIcon } from "./svg/bg-flag.svg";
import "../flag-icon.scss";

export const BGFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
